// extracted by mini-css-extract-plugin
module.exports = {"container":"DashboardBooksetList__container"};